import { isEmpty } from 'lodash-es';

import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets } from '../configs/constants';
import { pivotMarketShare } from '../../_shared/utils/transform-market-share-response';

// Response transformers
const aiMarketOverviewTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  return {
    data: {
      time_series: {
        growth: data.growth || {},
        indexed: data.indexed?.metrics || {},
        market_share: pivotMarketShare(data.market_share),
      },
    },
  };
};

// Request
export const fetchAiMarketOverview = () =>
  fetchDataByAsset(
    aiDashboardAssets.marketOverview,
    {},
    { transformResponse: (data) => aiMarketOverviewTransformResponse(data) }
  );
